"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _getCurrentlySelectedBlock = _interopRequireDefault(require("../utils/getCurrentlySelectedBlock")),
    _ExtendedRichUtils = require("./ExtendedRichUtils"),
    _StyleButton = _interopRequireDefault(require("./StyleButton"));

require("../styles/_editor-controls.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var HEADING_TYPES = [{
  label: _react["default"].createElement("span", {
    className: "editor-controls__headings__item"
  }, _react["default"].createElement("h1", null, "Heading 1")),
  value: "header-one"
}, {
  label: _react["default"].createElement("span", {
    className: "editor-controls__headings__item"
  }, _react["default"].createElement("h2", null, "Heading 2")),
  value: "header-two"
}, {
  label: _react["default"].createElement("span", {
    className: "editor-controls__headings__item"
  }, _react["default"].createElement("h3", null, "Heading 3")),
  value: "header-three"
}, {
  label: _react["default"].createElement("span", {
    className: "editor-controls__headings__item"
  }, _react["default"].createElement("h4", null, "Heading 4")),
  value: "header-four"
}, {
  label: _react["default"].createElement("span", {
    className: "editor-controls__headings__item"
  }, _react["default"].createElement("h5", null, "Heading 5")),
  value: "header-five"
}, {
  label: _react["default"].createElement("span", {
    className: "editor-controls__headings__item"
  }, _react["default"].createElement("h6", null, "Heading 6")),
  value: "header-six"
}],
    INLINE_CONTROLS = [{
  icon: "bold",
  value: "BOLD"
}, {
  icon: "italic",
  value: "ITALIC"
}, {
  icon: "underline",
  value: "UNDERLINE"
}],
    ALIGN_CONTROLS = [{
  icon: "alignleft",
  value: "left"
}, {
  icon: "aligncenter",
  value: "center"
}, {
  icon: "alignright",
  value: "right"
}, {
  icon: "alignjustified",
  value: "justify"
}],
    BLOCK_TYPES = [{
  icon: "bulletlist",
  value: "unordered-list-item"
}, {
  icon: "bulletnumeric",
  value: "ordered-list-item"
}, {
  icon: "blockquote",
  value: "blockquote"
}],
    StyleControls = function (_Component) {
  function StyleControls() {
    var _temp, _this;

    (0, _classCallCheck2["default"])(this, StyleControls);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2["default"])(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.handleHeaderChange = function (_ref) {
      var value = _ref.value,
          onToggle = _this.props.onToggle;
      onToggle(value)();
    }, _temp));
  }

  (0, _inherits2["default"])(StyleControls, _Component);

  var _super = _createSuper(StyleControls);

  return (0, _createClass2["default"])(StyleControls, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          editorState = _this$props.editorState,
          onToggleAlignment = _this$props.onToggleAlignment,
          onToggle = _this$props.onToggle,
          onToggleInline = _this$props.onToggleInline,
          selection = editorState.getSelection(),
          blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType(),
          _getCurrentlySelected = (0, _getCurrentlySelectedBlock["default"])(editorState),
          currentBlock = _getCurrentlySelected.currentBlock,
          alignment = currentBlock.getData().get(_ExtendedRichUtils.ALIGNMENT_DATA_KEY),
          currentStyle = editorState.getCurrentInlineStyle();

      return _react["default"].createElement("div", {
        className: "editor-controls"
      }, _react["default"].createElement(_uiKit.Dropdown, {
        className: "editor-controls__headings",
        options: HEADING_TYPES,
        value: HEADING_TYPES.find(function (_ref2) {
          var value = _ref2.value;
          return value === blockType;
        }) || {
          label: "HEADINGS",
          value: null
        },
        placeholder: "HEADINGS",
        onChange: this.handleHeaderChange,
        hideSeparators: !0,
        height: 40
      }), _react["default"].createElement("div", {
        className: "editor-controls__divider"
      }), _react["default"].createElement("div", {
        className: "editor-controls__block"
      }, INLINE_CONTROLS.map(function (_ref3) {
        var icon = _ref3.icon,
            value = _ref3.value;
        return _react["default"].createElement(_StyleButton["default"], {
          key: value,
          onToggle: onToggleInline(value)
        }, _react["default"].createElement(_uiKit.Icon, {
          name: icon,
          size: 13,
          color: currentStyle.has(value) ? "black" : "michael"
        }));
      })), _react["default"].createElement("div", {
        className: "editor-controls__divider"
      }), _react["default"].createElement("div", {
        className: "editor-controls__block"
      }, ALIGN_CONTROLS.map(function (_ref4) {
        var icon = _ref4.icon,
            value = _ref4.value;
        return _react["default"].createElement(_StyleButton["default"], {
          key: value,
          onToggle: onToggleAlignment(value)
        }, _react["default"].createElement(_uiKit.Icon, {
          name: icon,
          size: 15,
          color: value === alignment ? "black" : "michael"
        }));
      })), _react["default"].createElement("div", {
        className: "editor-controls__divider"
      }), _react["default"].createElement("div", {
        className: "editor-controls__block"
      }, BLOCK_TYPES.map(function (_ref5) {
        var icon = _ref5.icon,
            value = _ref5.value;
        return _react["default"].createElement(_StyleButton["default"], {
          key: value,
          onToggle: onToggle(value)
        }, _react["default"].createElement(_uiKit.Icon, {
          name: icon,
          size: 15,
          color: value === blockType ? "black" : "michael"
        }));
      })));
    }
  }]), StyleControls;
}(_react.Component);

exports["default"] = StyleControls;